import React, { useState, useEffect } from 'react';
import { SearchOutlined, CloseCircleFilled } from '@ant-design/icons';
import './styles.less';

export interface SearchBarProps {
  placeholder?: string;
  size?: 'small' | 'middle' | 'large';
  allowClear?: boolean;
  defaultValue?: string;
  value?: string;
  style?: React.CSSProperties;
  className?: string;
  onSearch?: (value: string) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPressEnter?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const prefixCls = 'search-bar';

export const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = '请输入搜索内容',
  size = 'middle',
  allowClear = false,
  defaultValue = '',
  value,
  style,
  className = '',
  onSearch,
  onChange,
  onPressEnter
}) => {
  const [inputValue, setInputValue] = useState(value || defaultValue);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (value !== undefined) {
      setInputValue(value);
    }
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange?.(e);
  };

  const handleSearch = () => {
    onSearch?.(inputValue);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
      onPressEnter?.(e);
    }
  };

  const handleClear = () => {
    setInputValue('');
    const mockEvent = {
      target: { value: '' }
    } as React.ChangeEvent<HTMLInputElement>;
    onChange?.(mockEvent);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const wrapperClass = [
    prefixCls,
    `${prefixCls}-${size}`,
    isFocused ? `${prefixCls}-focused` : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={wrapperClass} style={style}>
      <SearchOutlined
        className={`${prefixCls}-search-icon`}
        onClick={handleSearch}
      />
      <input
        type="text"
        className={`${prefixCls}-input`}
        placeholder={placeholder}
        value={inputValue}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {allowClear && inputValue && (
        <CloseCircleFilled
          className={`${prefixCls}-clear`}
          onClick={handleClear}
        />
      )}
    </div>
  );
};

export default SearchBar;